// A fir: a dense, full conifer — three broad stacked cones in a deep green,
// fuller and squatter than the spruce. Ported 1:1 from age-of-mcp's classic
// tree-fir.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.06, 0.1, 0.28, 5),
      color: "#3d2c1c", position: [0, 0.14, 0] },
    { geometry: new THREE.ConeGeometry(0.58, 0.74, 7),
      color: "#235539", position: [0, 0.6, 0] },
    { geometry: new THREE.ConeGeometry(0.44, 0.68, 7),
      color: "#2a6243", position: [0, 1.02, 0] },
    { geometry: new THREE.ConeGeometry(0.28, 0.62, 7),
      color: "#33724e", position: [0, 1.44, 0] },
  ];
}

export const treeFir = defineModel({
  id: "tree-fir",
  batchId: "standard",
  name: "Tree fir",
  tags: ["scenery","tree","fir","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree fir.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.5,
  parts: () => partsFor(),
  animations: [],
});
